var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-bootstrap-typeahead',{ref:"typeahead",staticClass:"form-control",attrs:{"type":"text","autocomplete":"off","data":_vm.products,"serializer":function (ref) {
	var sku = ref.sku;
	var name = ref.name;

	return (name + " (" + sku + ")");
},"placeholder":_vm.schema.default,"maxMatches":30},on:{"hit":_vm.handleHit},model:{value:(_vm.term),callback:function ($$v) {_vm.term=$$v},expression:"term"}})}
var staticRenderFns = []

export { render, staticRenderFns }